module.exports = __webpack_public_path__ + "static/assets/c1f07a1acde37050937fa22d2511d3c1.svg";